import { SvgIcon } from '@mui/material';

type MoneyOffProps = {
  color: string,
}
export const AttachMoney = ({
  color,
}: MoneyOffProps):JSX.Element  => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={ { color } }
  >
    <path d="M11.7999 10.9C9.52995 10.31 8.79995 9.7 8.79995 8.75C8.79995 7.66 9.80995 6.9 11.4999 6.9C13.2799 6.9 13.9399 7.75 13.9999 9H16.2099C16.1399 7.28 15.0899 5.7 12.9999 5.19V3H9.99995V5.16C8.05995 5.58 6.49995 6.84 6.49995 8.77C6.49995 11.08 8.40995 12.23 11.1999 12.9C13.6999 13.5 14.1999 14.38 14.1999 15.31C14.1999 16 13.7099 17.1 11.4999 17.1C9.43995 17.1 8.62995 16.18 8.51995 15H6.31995C6.43995 17.19 8.07995 18.42 9.99995 18.83V21H12.9999V18.85C14.9499 18.48 16.4999 17.35 16.4999 15.3C16.4999 12.46 14.0699 11.49 11.7999 10.9Z" />
  </SvgIcon>
);
